import { Button, ButtonProps } from "@mui/material";
import { grey } from "@mui/material/colors";
import { FC } from "react";

type Props = ButtonProps & {
  children: React.ReactNode;
  component?: React.ElementType;
};

export const OutlinedButtonCard: FC<Props> = ({ children, ...rest }) => (
  <Button
    variant="outlined"
    sx={[
      {
        borderColor: "black",
        color: "black",
        borderRadius: "20px",
        textTransform: "none",
        paddingInline: "30px",
        transition: "all 0.2s ease-in-out",
        fontWeight: 700,
      },
      {
        "&:hover": {
          borderColor: grey[900],
          color: "#fefefe",
          backgroundColor: "#030303",
          boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
        },
      },
    ]}
    {...rest}
  >
    {children}
  </Button>
);
